import axios from "axios";

export async function postGuestStatistic(colel_id, isAdmin) {
  if (isAdmin) {
      return await axios.get(`/manager/dashboard`);
  } else {
    return await axios.get(`/colel/dashboard?colel_id=${colel_id}`);
  }
}